import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-gallery',
	templateUrl: './gallery.component.html',
	styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/gallery/gallery.component.ts